import { useState } from 'react';
import { FlaskConical } from 'lucide-react';
import { useSite } from '../context/SiteContext';

export default function AgeGate() {
  const { site, loaded } = useSite();
  const [ok, setOk] = useState(() => localStorage.getItem('vq_gate_ok') === '1');
  if (ok || !loaded) return null;
  const gate = site.gate || {};
  if (gate.enabled === false) return null;

  return (
    <div className="fixed inset-0 z-[80] bg-[#0B0F12]/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="age-gate">
      <div className="bg-[#FAFAF8] max-w-md w-full p-8 fade-up">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 bg-[#0B0F12] flex items-center justify-center">
            <FlaskConical className="w-5 h-5 text-[#FAFAF8]" />
          </div>
          <p className="font-display font-black text-2xl uppercase">{gate.title || 'Research-use acknowledgement'}</p>
        </div>
        <p className="text-sm text-[#575B60] leading-relaxed">{gate.body}</p>
        <div className="mt-6 space-y-2.5 font-mono2 text-[11px] uppercase tracking-wider text-[#575B60]">
          <p>— I am 18 years of age or older</p>
          <p>— Products are for in-vitro laboratory research only</p>
          <p>— Not intended for human or veterinary use</p>
          <p>— Site content is not medical advice</p>
        </div>
        <button data-testid="age-gate-accept" onClick={() => { localStorage.setItem('vq_gate_ok', '1'); setOk(true); }}
          className="mt-7 w-full bg-[#0B0F12] text-[#FAFAF8] py-3.5 font-mono2 text-xs uppercase tracking-[0.2em] hover:bg-[#E54D2E] transition-colors">
          I understand — enter site
        </button>
      </div>
    </div>
  );
}
